import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {projectDocumentsApi} from '../api';
import {UpdateProjectDocumentDTO, UpdateProjectDocumentFileDTO} from '../model';
import {useCallback} from 'react';
import {useNotifications} from '../../../shared';

export const useProjectDocumentById = (documentId: string) => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const getProjectDocument = useQuery({
    queryKey: ['projectDocument', documentId],
    queryFn: () => projectDocumentsApi.getProjectDocumentById(documentId),
    enabled: !!documentId,
  });

  const refetchProjectDocument = useCallback(() => {
    queryClient.invalidateQueries({queryKey: ['projectDocument', documentId], refetchType: 'all'});
    queryClient.invalidateQueries({queryKey: ['projectDocuments', 'infinite'], refetchType: 'all'});
  }, [queryClient, documentId]);

  const updateProjectDocumentMutation = useMutation({
    mutationFn: (data: UpdateProjectDocumentDTO) => projectDocumentsApi.updateProjectDocument(documentId, data),
    onSuccess: () => {
      refetchProjectDocument();
      createNotification({
        title: 'Документ успешно обновлен',
        name: 'updateProjectDocument',
        theme: 'success',
      });
    },
  });

  const updateProjectDocumentFileMutation = useMutation({
    mutationFn: (data: UpdateProjectDocumentFileDTO) => projectDocumentsApi.updateProjectDocumentFile(documentId, data),
    onSuccess: () => {
      refetchProjectDocument();
      createNotification({
        title: 'Файл документа успешно обновлен',
        name: 'updateProjectDocumentFile',
        theme: 'success',
      });
    },
  });

  return {
    getProjectDocument,
    refetchProjectDocument,
    updateProjectDocumentMutation,
    updateProjectDocumentFileMutation,
  };
};

